import {createReducer} from '@reduxjs/toolkit';
import {getStatisticConsolidatedFeedbacks, getStatisticSubmittedFeedbacks} from './actions';
import {FeedbackDto} from '../../../dto/FeedbackDto';

type InitialState = {
    consolidated: FeedbackDto[];
    submitted: FeedbackDto[];
};

const initialState: InitialState = {
    consolidated: [],
    submitted: []
};

export const statistic = createReducer(initialState, (builder) =>
    builder
        .addCase(getStatisticConsolidatedFeedbacks.fulfilled, (state, action) => ({
            ...state,
            consolidated: action.payload
        }))
        .addCase(getStatisticSubmittedFeedbacks.fulfilled, (state, action) => ({
            ...state,
            submitted: action.payload
        }))
);
